import { render } from "./AddClaim.vue?vue&type=template&id=76cf0e3e&scoped=true"
import script from "./AddClaim.vue?vue&type=script&lang=js"
export * from "./AddClaim.vue?vue&type=script&lang=js"

import "./AddClaim.vue?vue&type=style&index=0&id=76cf0e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cf0e3e"]])

export default __exports__